module.exports = __webpack_public_path__ + "img/XLV.9089a070.png";